import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-deco-aqua-soft py-14 sm:py-20 px-4 sm:px-6 lg:px-8" style={{
    backgroundColor: "#FFFCF9",
    backgroundImage: "none"
  }} data-id="element-61" data-mp="c7tv9kju0su1">
      <div className="max-w-xl mx-auto text-center" data-id="element-62" data-mp="87js0fnfcgiv">
        <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-63" data-mp="m3wyktqf6xik">
          Último paso
        </p>
        <h2 className="font-serif text-2xl sm:text-4xl text-deco-forest font-semibold leading-snug mb-5" data-id="element-64" data-mp="h4153ofcmoh9">
          Hoy puedes empezar a crear algo{' '}
          <span className="italic text-deco-brick" data-id="element-65" data-mp="qwq43jtpq9vp">hermoso con tus manos</span>
        </h2>
        <p className="text-sm text-deco-forest/65 leading-relaxed mb-9" data-id="element-66" data-mp="14uohon07m2a5">
          Descargas la guía, imprimes tu primera plantilla y esa misma tarde
          tienes una pieza terminada. Sin experiencia y sin saber dibujar.
        </p>

        <button onClick={scrollToPurchase} className="w-full sm:w-auto px-10 py-4 rounded-full bg-deco-brick text-white font-semibold text-sm tracking-wide shadow-lg hover:bg-deco-brick-dark transition-colors duration-200" data-id="element-67" data-mp="2c6hh49q4bnd5">
          QUIERO MI GUÍA AHORA
        </button>

        <div className="flex items-center justify-center gap-2 mt-4 text-[11px] text-deco-forest/50 font-medium" data-id="element-68" data-mp="2r2p0x8xm6mrw">
          <ShieldCheck size={14} data-id="element-69" data-mp="2v2zfvb3dwniw" />
          <span data-id="element-70" data-mp="302lw7teiejvx">Acceso inmediato · Producto digital · Pago seguro</span>
        </div>
      </div>
    </section>;
}